import { render, staticRenderFns } from "./side-bar-rtl.vue?vue&type=template&id=8855f320&scoped=true&"
import script from "./side-bar-rtl.vue?vue&type=script&lang=js&"
export * from "./side-bar-rtl.vue?vue&type=script&lang=js&"
import style0 from "./side-bar-rtl.vue?vue&type=style&index=0&id=8855f320&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8855f320",
  null
  
)

component.options.__file = "side-bar-rtl.vue"
export default component.exports